import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Bell } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function Alerts() {
  const [params] = useSearchParams();
  const [msg, setMsg] = useState("Un momento…");
  useEffect(() => {
    const c = params.get("confirmar"), b = params.get("baja");
    if (!c && !b) { setMsg("Enlace no válido."); return; }
    api.post(c ? "/alerts/confirm" : "/alerts/unsubscribe", { token: c || b })
      .then((r) => setMsg(c ? `Alerta activada: «${r.data.label}». Te avisaremos por email en cuanto se publique un anuncio que encaje.` : `Alerta borrada: «${r.data.label}». No recibirás más avisos de esta búsqueda.`))
      .catch((e) => setMsg(errMsg(e)));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="alerts-page">
      <Bell size={36} className="mx-auto text-[#DC2626]" />
      <h1 className="font-display font-black text-4xl uppercase text-[#0B1D3A] mt-4">Alertas del mercado</h1>
      <p className="text-slate-700 mt-4" data-testid="alerts-message">{msg}</p>
      <Link to="/mercado" className="inline-block mt-8 font-bold text-[#2563EB]" data-testid="alerts-back">Ir al mercado →</Link>
    </div>
  );
}
